import { memo, useEffect } from "react";
import { Button, Checkbox, Popconfirm, Space, Table, TableProps, Tag } from "antd";
import { useTranslation } from "react-i18next";
import { mdlTablePagination } from "../../../models/ui-models/TablePagination";
import { QuestionCircleOutlined } from '@ant-design/icons';
import { mdlHotelRoomAndType } from "../../../models/domain/HotelRoomAndType";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning } from "@fortawesome/free-solid-svg-icons";

export type RoomAndTypeTableProps = {
    fnSelectAll?: any;
    onTableItemSelect?: any;
    tableItems?: mdlHotelRoomAndType[];
    onDelete?: Function;
    onEdit?: Function;
    pagination: mdlTablePagination;
    onTableParamsChange?: Function;
    selectedRoomList?: string[];
    selectedRoomTypeList?: string[];
    selectedRoomAndTypeList?: string[];
    selectedHotel?:string;
}

export const RoomAndTypeTable = memo(function RoomAndTypeTable(props: RoomAndTypeTableProps) {
    const { t } = useTranslation();

    useEffect(() => {
    }, [props]);


    const handleToEdit = (record:mdlHotelRoomAndType) => {
        props.onEdit && props.onEdit(record);
    }

    const checkList = (id:string) => {
        return (props.selectedRoomAndTypeList?.find(x => x==id) != undefined) as boolean;
    }
    const columns: TableProps<mdlHotelRoomAndType>['columns'] = [
        {
            title: <>
                <Checkbox onClick={props.fnSelectAll} checked={props.selectedRoomAndTypeList?.length == props.tableItems?.length}></Checkbox>
            </>,
            key: 'check',
            width:30,
            render: (_, record) => (
                <Space size="middle">
                    <Checkbox onChange={props.onTableItemSelect} checked={checkList(record.id)} value={record.id}></Checkbox>
                </Space>
            ),
        },
        {
            title: t("definitions.hotels.roomName"),
            dataIndex: 'roomName',
            key: 'roomName'
        },
        {
            title: t("definitions.hotels.roomTypeName"),
            dataIndex: 'roomTypeName',
            key: 'roomTypeName'
        },
        {
            title: t("definitions.hotels.adults"),
            dataIndex: 'adults',
            key: 'adults'
        },
        {
            title: t("definitions.hotels.maxChilds"),
            dataIndex: 'maxChilds',
            key: 'maxChilds'
        },
        {
            title: t("definitions.hotels.maxPax"),
            dataIndex: 'maxPax',
            key: 'maxPax'
        },
        {
            title: t("common.actions"),
            width: 100,
            key: 'action',
            render: (_, record) => (
                <Space size="middle">
                <Button className="btn btn-primary" onClick={() => handleToEdit(record)}>
                        {t("common.edit")}
                    </Button>
                    <Popconfirm
                        title={t("common.deleteWarning")}
                        description={t("common.deleteDescription")}
                        okText={t("common.okConfirm")}
                        cancelText={t("common.cancelConfirm")}
                        icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                        onConfirm={() => props.onDelete ? props.onDelete(record.id) : undefined}
                    >
                        <Button type="primary" danger>
                            {t("common.delete")}
                        </Button>
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    const handleTableChange: TableProps<mdlHotelRoomAndType>['onChange'] = (pagination, filters, sorter) => {
        props.onTableParamsChange && props.onTableParamsChange(pagination, filters);
    }

    return (
        <>
        <div className="row">
                <div className="col-sm-12">
                    <Table<mdlHotelRoomAndType>
                        onChange={handleTableChange}
                        size="middle"
                        columns={columns}
                        pagination={props.pagination}
                        scroll={{ x: 'max-content' }}
                        dataSource={props.tableItems?.map((data: mdlHotelRoomAndType, index: number) => ({ ...data, key: index }))}
                    />
                </div>
        </div>
        </>
    )
})